import { render, staticRenderFns } from "./productcentersj.vue?vue&type=template&id=4ae80c2c&scoped=true&"
import script from "./productcentersj.vue?vue&type=script&lang=js&"
export * from "./productcentersj.vue?vue&type=script&lang=js&"
import style0 from "./productcentersj.vue?vue&type=style&index=0&id=4ae80c2c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ae80c2c",
  null
  
)

export default component.exports